// extracted by mini-css-extract-plugin
export default {"container":"applications-components-HeaderApp-header-module__container","containerVTB":"applications-components-HeaderApp-header-module__containerVTB"};
    if(module.hot) {
      // 1707476366310
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  